import { useTranslation } from 'react-i18next';
import Container from '@mui/material/Container';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Container
      maxWidth="xl"
      sx={{
        textAlign: "center",
        fontSize: 12,
        color: "#C7C7C7",
      }}
      className={'hidePrint'}
    >
      <div>©OECD {new Date().getFullYear()}</div>
      <div dangerouslySetInnerHTML={{ __html: t('footerDisclaimer') }}>
      </div>
    </Container>
  )
};

export default Footer;
